import {
    countries
  } from '../helpers/countries';
  import {
    provinces
  } from '../helpers/provinces';
  import {
    applicantFields,
    premiumField,
    legalGuardianFields,
    studentNumberFields
  } from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'rimissis';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Agent'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName), 
    fieldGroups.detailedBeneficiaryGroup(clientName), 
    fieldGroups.bqGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(true),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
    fieldGroups.attachmentGroup(),
  ];
}
    
export function fields() {
  return {
    contact_details_fields: [
      ...legalGuardianFields(false)
    ],
    dependent_fields: [
      ...applicantFields('*', [
          {value: 'dependent', text: 'Dependent Child'},
          {value: 'travelling companion', text: 'Travelling Companion'},
          {value: 'parent', text: 'Parent/Guardian'},
          {value: 'spouse', text: 'Spouse'}
        ]),
      ...studentNumberFields('*'),
    ],
    coverage_fields: [
     {
        key_path: ['application', 'additional_data', 'coverage_type'],
        as: 'Policy Type',
        type: 'dropdown',
        options: [
          {value: 'standard', text: 'Standard'},
          {value: 'enhanced', text: 'Enhanced'},
          {value: 'premium', text: 'Premium'}
        ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries()
      },
      {
        key_path: ['application', 'additional_data', 'destination_province'],
        as: 'Destination Province',
        type: 'dropdown',
        options: [
            {
              value: 'N/A',
              text: 'N/A'
            },
            ...provinces('CA')
          ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'tracking_code'],
          value: 'RIMI004'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'destination_province'],
        as: 'Destination Province',
        type: 'dropdown',
        options: [
            {
              value: 'N/A',
              text: 'N/A'
            },
            ...provinces('CA').filter(province => (province.value !== 'QC'))
          ],
        show_if: [{
          key_path: ['application', 'additional_data', 'tracking_code'],
          value: 'RIMI004'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'other_plan'],
        as: 'Other Insurance',
        type: 'dropdown',
        options: [
          {value: 'yes', text: 'Yes'},
          {value: 'no', text: 'No'}
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'name_of_other_plan'],
        as: 'Name of Other Plan',
        show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: 'yes'
        }]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/clients/rimissis.js